import { SellarDistributionAvailabilityDistributionDeliveryEstimateTimetableListResponseType } from "@sellar-io/api-v2/types";
import { createContext } from "react";

export type BuyerRelationshipDeliveryEstimateContextType = {
  deliveryEstimates: SellarDistributionAvailabilityDistributionDeliveryEstimateTimetableListResponseType;
  getDistributionDeliveryEstimate: (
    supplierId: number,
  ) =>
    | SellarDistributionAvailabilityDistributionDeliveryEstimateTimetableListResponseType[number]
    | undefined;
};

export const BuyerRelationshipDeliveryEstimateContext =
  createContext<BuyerRelationshipDeliveryEstimateContextType | null>(null);
